<div class='full-form'>
  <language-select
    [selected]='appService.language.value'
    (changed)='appService.language.next($event)'
    [languageCodes]='appService.supportedLanguageCodes'
  [activeLanguageCodes]='datasetMCS.activeLanguageCodes'></language-select>

  @if (datasetACS.loading.value) {
    <mat-progress-bar class='mt-24 mb-24' style='min-width:300px' mode="indeterminate"></mat-progress-bar>
  }

  @if (datasetACS.ready.value) {
    <div class='mt-24'>
      @if (!datasetRS.record.value && !datasetACS.loading.value) {
        <p>Questa traduzione non è ancora presente!</p>
      }
      @if (formViewerService.initialized && formViewerService.formGroup) {
        <form autocomplete="off" name='form' [formGroup]="formViewerService.formGroup" class="fx-column fx-justify-start fx-items-stretch fx-lt-lg-justify-stretch fx-lt-lg-items-stretch">
          <div class="product-publish-on-web">
            <label class="input-label section-title"><b>Pubblico</b></label>
            <div class="base-textfield base-textfield-large">
              <form-input-viewer
                [formInputDefinition]='fileterFields.get("public_product_on_web")'
                [formGroup]='formViewerService.formGroup'
                [formControlKey]='formViewerService.controlKeyMap["public_product_on_web"]'
                [dataContainerService]='formViewerService.dataContainerService'
                [data]='formViewerService.record'
              ></form-input-viewer>
            </div>
          </div>
          <label class="input-label section-question">
            Descrivi la tua attività
          </label>
          <div class="base-textfield base-textfield-large">
            <form-input-viewer
              [formInputDefinition]='fileterFields.get("description")'
              [formGroup]='formViewerService.formGroup'
              [formControlKey]='formViewerService.controlKeyMap["description"]'
              [dataContainerService]='formViewerService.dataContainerService'
              [data]='formViewerService.record'
            ></form-input-viewer>
          </div>
          <div class="instruction with-bg">
            <label class="input-label section-question">Descrizione completa</label>
            <p class="instruction">
              Descrivi le attività che si svolgeranno durante la visita
            </p>
            <p class="instruction">
              Cosa vedranno? Cosa succederà? Come finirà?
            </p>
            <p class="instruction">
              Non scrivere "noi", "nostro", il nome della tua azienda o copiare e incollare testo da un sito Web esistente.
            </p>
          </div>
          <div class="base-textfield base-textfield-large">
            <form-input-viewer
              [formInputDefinition]='fileterFields.get("full_description")'
              [formGroup]='formViewerService.formGroup'
              [formControlKey]='formViewerService.controlKeyMap["full_description"]'
              [dataContainerService]='formViewerService.dataContainerService'
              [data]='formViewerService.record'
            ></form-input-viewer>
          </div>
        </form>
      }
      <div class="mt-24 mb-24 fx-row fx-justify-end fx-items-center" style="gap: 10px">
        <button color='accent' [disabled]='!formViewerService.formGroup.valid' mat-flat-button (click)='onSave()'>
          @if (!datasetACS.loading.value) {
            <span>{{ (hasNext ? "Salva e vai avanti" : "Salva") | translate }}</span>
          }
          @if (datasetACS.loading.value) {
            <span>Azione in corso ...</span>
          }
        </button>
      </div>
    </div>
  }
</div>